import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SectionHero from '../../components/sections/SectionHero';
import SectionTrustBar from '../../components/sections/SectionTrustBar';
import SectionServices from '../../components/sections/SectionServices';
import SectionMidCTA from '../../components/sections/SectionMidCTA';
import SectionAIBlock from '../../components/sections/SectionAIBlock';
import SectionProcess from '../../components/sections/SectionProcess';
import SectionWhyUs from '../../components/sections/SectionWhyUs';
import SectionAreas from '../../components/sections/SectionAreas';
import SectionTestimonials from '../../components/sections/SectionTestimonials';
import SectionFAQ from '../../components/sections/SectionFAQ';
import SectionFinalCTA from '../../components/sections/SectionFinalCTA';

const services = [
  {
    icon: 'ri-seedling-line',
    title: 'Scuba Certification in Miami',
    description:
      'Begin your scuba journey with PADI, SSI, or SDI Open Water certification in Miami\'s warm, crystal-clear coastal waters. Flexible schedules year-round from Pier 5, Biscayne Blvd.',
    image:
      'https://public.readdy.ai/ai/img_res/d87eaf32295435ed138b94bbbc46a531.jpg',
  },
  {
    icon: 'ri-ship-line',
    title: 'Miami Dive Boat Trips',
    description:
      'Explore Biscayne Bay, Biscayne National Park, and Miami\'s offshore reefs from our dedicated dive boat at Pier 5 — one of Miami\'s most sought-after launching points.',
    image:
      'https://readdy.ai/api/search-image?query=dive%20boat%20Miami%20Biscayne%20Bay%20Florida%20pier%20ocean%20tropical%20water%20scuba%20divers%20professional%20boat%20trip%20reef%20guided%20tour%20Miami%20keys%20beautiful%20day%20cinematic&width=600&height=400&seq=loc-svc-2-v3&orientation=landscape',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Guided Reef & Wreck Dives',
    description:
      'Discover Miami\'s spectacular underwater world — coral reefs, tropical fish, and historic wrecks with expert local dive guides who know every site intimately.',
    image:
      'https://readdy.ai/api/search-image?query=Miami%20underwater%20coral%20reef%20tropical%20fish%20scuba%20diving%20guided%20dive%20clear%20warm%20water%20beautiful%20marine%20life%20Florida%20Keys%20reef%20diving%20colorful%20tropical%20ocean%20Biscayne&width=600&height=400&seq=loc-svc-3-v3&orientation=landscape',
  },
  {
    icon: 'ri-camera-line',
    title: 'Snorkeling & Private Charters',
    description:
      'Private snorkeling tours, sunset charters, and fully customized dive experiences for families, couples, and groups in Miami\'s stunning tropical waters.',
    image:
      'https://readdy.ai/api/search-image?query=snorkeling%20Miami%20Biscayne%20Bay%20private%20boat%20charter%20tropical%20clear%20turquoise%20water%20luxury%20private%20tour%20family%20snorkel%20trip%20beautiful%20Florida%20Keys%20sunset&width=600&height=400&seq=loc-svc-4-v3&orientation=landscape',
  },
];

const steps = [
  {
    number: '01',
    title: 'Book Your Miami Experience',
    description: 'Contact our team to check availability, choose your program, and reserve your spot at Pier 5.',
    icon: 'ri-calendar-check-line',
    detail: 'Same-week availability often possible. Call or fill out the form to confirm.',
  },
  {
    number: '02',
    title: 'Arrive at Pier 5',
    description: 'Come to 401 Biscayne Blvd, Pier 5, Slip 33 — right on the waterfront in the heart of Miami.',
    icon: 'ri-map-pin-2-line',
    detail: 'Easy parking. Accessible from all Miami neighborhoods and the airport.',
  },
  {
    number: '03',
    title: 'Train & Dive in Miami',
    description: 'World-class instruction, pool sessions, and open water dives in Miami\'s beautiful warm coastal environment.',
    icon: 'ri-anchor-line',
    detail: 'Warm water, clear visibility, and spectacular marine life year-round.',
  },
  {
    number: '04',
    title: 'Certified in Miami — Dive Anywhere',
    description: 'Leave with your internationally recognized certification and the skills to dive anywhere in the world.',
    icon: 'ri-award-line',
    detail: 'PADI, SSI, and SDI certifications accepted at every dive center globally.',
  },
];

const reasons = [
  {
    icon: 'ri-map-pin-2-line',
    title: 'Prime Miami Waterfront Location',
    description: 'Right on Biscayne Bay at Pier 5 — easily accessible from all Miami neighborhoods with immediate access to world-class dive sites.',
  },
  {
    icon: 'ri-sun-line',
    title: 'Year-Round Perfect Diving',
    description: 'Miami\'s warm, clear waters make it one of the best year-round diving destinations in the USA. Water temps 75–85°F with 60ft+ visibility.',
  },
  {
    icon: 'ri-anchor-line',
    title: 'Miami\'s Finest Dive Sites',
    description: 'Biscayne National Park, Miami Beach reefs, historic wrecks, and the start of the Florida Keys reef tract — all accessible from Pier 5.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Miami\'s Most Trusted Dive Team',
    description: 'Over 15 years serving Miami divers. Our instructors know every site, every current, and every condition in South Florida waters.',
  },
  {
    icon: 'ri-award-line',
    title: 'Miami\'s Most Accredited Dive Center',
    description: 'The only Miami dive center certified by PADI, SSI, SDI, TDI, and ERDI — giving you the most recognized credentials anywhere in the world.',
  },
];

const miamiareas = [
  'Downtown Miami', 'Brickell', 'Miami Beach', 'South Beach', 'Coconut Grove',
  'Coral Gables', 'Wynwood', 'Little Havana', 'Key Biscayne',
  'Aventura', 'Hallandale', 'Fort Lauderdale', 'Key Largo', 'Homestead',
  'Biscayne National Park',
];

const testimonials = [
  {
    name: 'Jordan M.',
    role: 'Open Water Certified — Downtown Miami',
    rating: 5,
    quote:
      'I live in Brickell and Ace Diving was the obvious choice — waterfront location, a real dive boat, and the most knowledgeable instructors I\'ve come across in Miami. Got certified in 4 days and was diving Biscayne Bay on day three. The experience was genuinely incredible.',
    avatar:
      'https://readdy.ai/api/search-image?query=professional%20young%20man%20portrait%20headshot%20casual%20outdoor%20Miami%20confident%20smiling%20natural%20warm%20light&width=100&height=100&seq=avatar-loc-1-v3&orientation=squarish',
  },
  {
    name: 'Camille F.',
    role: 'Guided Reef Dive — Miami Beach',
    rating: 5,
    quote:
      'I visited Miami and booked a private reef dive through Ace Diving. Our guide was exceptional — knew every species, every coral formation, and kept us completely at ease the entire time. Hands down one of the best dive experiences I\'ve had anywhere in the world.',
    avatar:
      'https://readdy.ai/api/search-image?query=woman%20professional%20portrait%20smiling%20casual%20outdoor%20headshot%20warm%20natural%20light%20clean%20background%20friendly&width=100&height=100&seq=avatar-loc-2-v3&orientation=squarish',
  },
  {
    name: 'Marco A.',
    role: 'Advanced Open Water — Coral Gables',
    rating: 5,
    quote:
      'I\'ve been training with Ace Diving for 3 years — started with Open Water, got Advanced, and am now halfway through my Rescue course. The consistency and quality of their instruction at every level is unmatched in Miami. There\'s simply no comparison.',
    avatar:
      'https://readdy.ai/api/search-image?query=Latin%20professional%20man%20casual%20headshot%20portrait%20friendly%20confident%20warm%20natural%20background%20outdoor&width=100&height=100&seq=avatar-loc-3-v3&orientation=squarish',
  },
];

const faqs = [
  {
    question: 'Where can I take scuba diving lessons in Miami?',
    answer:
      'Ace Diving Miami offers scuba lessons from their waterfront facility at 401 Biscayne Blvd, Pier 5, Slip 33 in Miami. They provide PADI, SSI, and SDI certifications with real boat-based training on Biscayne Bay — one of the most scenic and biodiverse diving environments in the United States.',
  },
  {
    question: 'What are the best dive sites near Miami?',
    answer:
      'Miami offers exceptional diving at Biscayne National Park, Fowey Rocks Lighthouse, the Emerald Reef, Triumph Reef, and several historic wrecks accessible from Pier 5. Ace Diving\'s guides know every site — call +1 786-241-3194 to find the best dive for your level.',
  },
  {
    question: 'Can I go scuba diving in Miami as a complete beginner?',
    answer:
      'Absolutely. Ace Diving Miami specializes in beginner scuba programs. Their Open Water certification course can be completed in 3–5 days and includes everything from eLearning theory to real ocean dives on Biscayne Bay. No prior experience required — just basic swimming ability.',
  },
  {
    question: 'How do I book a dive trip or snorkeling charter in Miami?',
    answer:
      'Call Ace Diving at +1 786-241-3194 or email info@ace-diving.com to check dive boat availability and book your Miami experience. They offer guided reef dives, snorkeling trips, private charters, and Biscayne National Park excursions throughout the year.',
  },
  {
    question: 'Does Ace Diving Miami offer equipment rental?',
    answer:
      'Yes. Ace Diving Miami provides full equipment rental — BCD, regulator, wetsuit, mask, fins, and dive computer. All gear is professionally maintained and properly fitted to ensure safety and comfort on every Miami dive.',
  },
];

export default function Location() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <main>
        <SectionHero
          eyebrow="Scuba Diving Miami, Florida"
          headline={
            <>
              Miami&apos;s Finest<br />
              <span className="text-[#00B4D8]">Dive Center —</span><br />
              On the Water.
            </>
          }
          subheadline="Scuba certification, guided reef dives, boat trips, private charters, and technical diving programs from Miami's premier waterfront location at Pier 5, 401 Biscayne Blvd."
          cta1={{ text: 'Book in Miami', href: '#contact' }}
          cta2={{ text: 'Find Our Location', href: '#service-areas' }}
          stats={[
            { value: 'Pier 5', label: '401 Biscayne Blvd' },
            { value: '12mo', label: 'Year-Round Diving' },
            { value: '80°F+', label: 'Avg Water Temp' },
            { value: '60ft+', label: 'Typical Visibility' },
          ]}
          backgroundImage="https://readdy.ai/api/search-image?query=Miami%20Florida%20Biscayne%20Bay%20aerial%20view%20turquoise%20blue%20water%20city%20skyline%20waterfront%20pier%20marina%20boat%20beautiful%20tropical%20Florida%20Keys%20coastline%20stunning%20dramatic%20light%20golden%20hour%20cinematic&width=1920&height=1080&seq=hero-loc-v3&orientation=landscape"
          backgroundAlt="Miami Florida scuba diving — Biscayne Bay aerial view"
        />
        <SectionTrustBar />
        <SectionServices
          eyebrow="Miami Diving Services"
          headline="Scuba Diving Services in Miami, Florida — Pier 5, Biscayne Bay"
          services={services}
          ctaText="Book in Miami"
        />
        <SectionMidCTA
          headline="Ready to Dive Miami's Incredible Waters?"
          subheadline="Our Pier 5 location on Biscayne Bay gives you direct access to Miami's best dive sites. Let's plan your perfect Miami diving experience."
          cta1={{ text: 'Book Your Experience', href: '#contact' }}
          cta2={{ text: '+1 786-241-3194', href: 'tel:+17862413194' }}
        />
        <SectionAIBlock
          eyebrow="Diving in Miami"
          headline="Ace Diving Miami — Waterfront Scuba Training on Biscayne Bay"
          lead="Ace Diving Miami is South Florida's leading waterfront dive center, offering scuba certification, guided reef and wreck dives, private boat charters, snorkeling tours, and technical diving from Pier 5, 401 Biscayne Blvd — right on Biscayne Bay."
          paragraphs={[
            'Miami\'s warm, clear waters and proximity to Biscayne National Park, offshore coral reefs, and the Florida Keys make it one of the best year-round scuba diving destinations in the United States. Ace Diving\'s Pier 5 location puts every student and diver directly on the water from their very first session.',
            'With PADI, SSI, SDI, TDI, and ERDI accreditation, Ace Diving Miami serves everyone from complete beginners to technical divers — offering the most comprehensive scuba training and dive experience program in the greater Miami area.',
          ]}
          tags={[
            'Scuba Miami',
            'Biscayne Bay Diving',
            'Biscayne National Park',
            'Miami Reef Dives',
            'Snorkeling Miami',
            'Private Dive Charter',
            'Miami Certification',
            'Pier 5 Miami',
          ]}
        />
        <SectionProcess
          eyebrow="How to Dive With Us"
          headline="Book Your Miami Diving Experience in 4 Simple Steps"
          steps={steps}
          ctaText="Book in Miami"
        />
        <SectionWhyUs
          eyebrow="Miami Dive Authority"
          headline="Why Miami Divers Choose Ace Diving"
          reasons={reasons}
          image="https://readdy.ai/api/search-image?query=Miami%20Biscayne%20Bay%20waterfront%20scuba%20divers%20boat%20pier%20ocean%20beautiful%20day%20Florida%20tropical%20coastline%20dive%20boat%20preparation%20equipment%20professional%20operation%20cinematic&width=700&height=900&seq=why-loc-v3&orientation=portrait"
          imageAlt="Ace Diving Miami — Biscayne Bay waterfront operation"
          ctaText="Book in Miami"
          badge1={{ label: 'Miami FL 33132', sublabel: '401 Biscayne Blvd · Pier 5' }}
          badge2={{ value: '15+', label: 'Miami Years' }}
        />
        <SectionAreas
          eyebrow="Miami Service Areas"
          headline="Dive Training Across All of Miami & South Florida"
          description="From Pier 5 on Biscayne Blvd, we serve divers from every Miami neighborhood. Our location gives direct access to Biscayne National Park and the start of the Florida Keys reef system — some of the most spectacular diving in the United States."
          areas={miamiareas}
          ctaText="Book Your Miami Dive"
          showMap
        />
        <SectionTestimonials
          eyebrow="Miami Diver Reviews"
          headline="What Miami Divers Say About Ace Diving"
          testimonials={testimonials}
          ctaText="Book in Miami"
        />
        <SectionFAQ
          eyebrow="Miami Diving Questions"
          headline="Common Questions About Scuba Diving in Miami"
          faqs={faqs}
        />
        <SectionFinalCTA
          eyebrow="Book in Miami"
          headline="Ready to Dive Miami's Incredible Waters?"
          subheadline="Whether you want your first certification or your next guided reef dive — Ace Diving Miami is on the water and ready to take you there."
          ctaText="Book in Miami"
        />
      </main>
      <Footer />
    </div>
  );
}
